export const COOKIES_KEYS = {
  accessToken: 'tolstoyAccessToken',
  appKey: 'tolstoyAppKey',
};

export const LOCAL_STORAGE_KEYS = {
  appKey: 'tolstoyAppKey',
  appUrl: 'tolstoyAppUrl',
  owner: 'owner',
  ghostsAccount: 'ghostAccount',
  accessToken: 'tolstoyAccessToken',
  host: 'shopifyHost',
};
